import _ from 'underscore';
import EventBus from './eventbus';
import SocketEvents from '../events/socket';

var defaults = {
	debug: false,
	logging: false,
	hubName: 'notificationHub',
	signalRUrl: '',
	signalRToken: 0,
	useDefaultPath: false
};

function Socket(options) {
	this.options = _.extend({}, defaults, options || {});

	// setup connection and hub
	this.connection = $.hubConnection(this.options.signalRUrl, this.options);
	this.hub = this.connection.createHubProxy(this.options.hubName);
	this.hub.url = this.options.signalRUrl; // Enable cross-domain requests (CORS)

	// initialize connection and hub events
	this.initEvents();

	// connect
	this.connect();
}

Socket.prototype = {

	// initialize the events
	initEvents: function() {
		// connection events
		this.connection.reconnecting(this.onReconnecting);
		this.connection.disconnected(this.onDisconnected);

		this.hub.on('notification', this.onNotification);

		// all to the same handler
		this.hub.on('adminnotification', this.onAdminNotification);
		this.hub.on('notificationcounterpartysamefirm', this.onAdminNotification);
		this.hub.on('notificationdeadlinenotmet', this.onAdminNotification);
		this.hub.on('notificationdenied', this.onAdminNotification);

		this.hub.on('log', this.onLogMessage);
	},

	// connect with the server
	connect: function() {
		this.connection.start({ transport: 'auto'})
			.done(this.connectionEstablished.bind(this))
			.fail(this.connectionError.bind(this));
	},

	/* event handlers */
	// socket reconnecting
	onReconnecting: function() {
		EventBus.trigger(SocketEvents.RECONNECTING);
	},

	// socket disconnected
	onDisconnected: function() {
		EventBus.trigger(SocketEvents.DISCONNECTED);
	},

	// socket connected
	// fires event with connection ID
	connectionEstablished: function() {
		EventBus.trigger(SocketEvents.CONNECTED, this.connection.id);
		this.subscribe();
	},

	// subscribe user
	subscribe: function() {
		this.hub.invoke('Subscribe', this.options.signalRToken);
	},

	// socket connection error
	// fires event with message and error event
	connectionError: function(e) {
		EventBus.trigger(SocketEvents.ERROR, e.message, e);
	},

	// hub notification received
	onNotification: function(response) {
		response = JSON.parse(response);
		EventBus.trigger(SocketEvents.NOTIFICATION, response);
	},

	// hub admin notification received
	onAdminNotification: function(response) {
		response = JSON.parse(response);
		EventBus.trigger(SocketEvents.ADMINNOTIFICATION, response);
	},

	// hub log message received
	onLogMessage: function(log) {}
};

export default Socket;

